import { render } from "./ConfirmationDialog.vue?vue&type=template&id=ca22687c&scoped=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"

import "./dialog.scss?vue&type=style&index=0&id=ca22687c&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca22687c"]])

export default __exports__